import { render, staticRenderFns } from "./iframeView.vue?vue&type=template&id=162c4728&scoped=true"
import script from "./iframeView.vue?vue&type=script&lang=js"
export * from "./iframeView.vue?vue&type=script&lang=js"
import style0 from "./iframeView.vue?vue&type=style&index=0&id=162c4728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c4728",
  null
  
)

export default component.exports